const all = ['dictation']
const start = [...all, 'start']

export const dictationKeys = {
  all,
  start,
}
